var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import profileDI from "@frameworks/salesjourney/components/Features/Profile/di/serviceLocator";
import ErrorNotification, { ErrorDisplayType, } from "@frameworks/salesjourney/components/Generic/ErrorNotification";
import { ELocalStorageKeys } from "@domains/salesFeatures/Common/entities/ELocalStorageKeys";
var AuthGuardHOC = function (props) {
    var navigate = useNavigate();
    var _a = __read(useState(false), 2), useLoggedIn = _a[0], setUserLoggedIn = _a[1];
    var _b = __read(React.useState(false), 2), showSessionPopup = _b[0], setSessionShowPopup = _b[1];
    useEffect(function () {
        var access_token = localStorage.getItem(ELocalStorageKeys.AccessToken);
        if (access_token) {
            profileDI.profile
                .getProfileImage()
                .then(function (image) {
                setUserLoggedIn(true);
                // navigate("/");
            })
                .catch(function (error) {
                var errorCode = error.getHttpCode();
                if (errorCode === 401 || errorCode === 403) {
                    // console.log("setSessionShowPopup");
                    setSessionShowPopup(true);
                    // setErrorData(error as EdelError);
                }
            });
        }
        else {
            navigate("/login");
        }
    }, []);
    return (React.createElement(React.Fragment, null,
        useLoggedIn && React.createElement(props.component, __assign({}, props)),
        showSessionPopup && (React.createElement(ErrorNotification, { displayType: ErrorDisplayType.POPUP, showSessionPopup: showSessionPopup, onClose: setSessionShowPopup }))));
};
export default AuthGuardHOC;
